import Vue from "vue";
import Router from "vue-router";
import AuthGuard from "@/guards/auth";

Vue.use(Router);

export default new Router({
    mode: "history",
    routes: [
        {
            path: "/",
            redirect: "/dashboard",
            component: () => import("@/views/theme/Base"),
            children: [
                {
                  path: "/profile",
                  name: "profile",
                  beforeEnter: AuthGuard,
                  component: () => import("@/views/pages/profile/Profile.vue"),
                  meta: {
                      permissions: []
                  }
                },
                {
                    path: "/dashboard",
                    name: "dashboard",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/dashboard/Dashboard.vue"),
                    meta: {
                        permissions: []
                    }
                },
                {
                    path: "/offer",
                    name: "offer",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/offer/Offer.vue"),
                    meta: {
                        permissions: ['offers-create']
                    }
                },
                {
                    path: "/offer/:id",
                    name: "edit-offer",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/offer/EditOffer.vue"),
                    meta: {
                        permissions: ['offers-edit']
                    }
                },
                {
                    path: "/quick-offer",
                    name: "new-quick-offer",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/quickOffer/NewQuickOffer.vue"),
                    meta: {
                        permissions: ['offers-create']
                    }
                },
                {
                    path: "/quick-offer/:id",
                    name: "update-quick-offer",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/quickOffer/UpdateQuickOffer.vue"),
                    meta: {
                        permissions: ['offers-edit'],
                        hideSubheader: true,
                        fluidContainer: true
                    }
                },
                {
                  path: "/live-list",
                  name: "live-list",
                  beforeEnter: AuthGuard,
                  component: () => import("@/views/pages/liveList/LiveList.vue"),
                  meta: {
                      permissions: ['live-list-view-all']
                  }
                },
                {
                  path: "/price-lists",
                  name: "price-lists",
                  beforeEnter: AuthGuard,
                  component: () => import("@/views/pages/priceLists/ListPriceLists.vue"),
                  meta: {
                      permissions: ['price-lists-view-self', 'price-lists-view-team', 'price-lists-view-all']
                  }
                },
                {
                  path: "/price-lists/create",
                  name: "price-lists-create",
                  beforeEnter: AuthGuard,
                  component: () => import("@/views/pages/priceLists/EditPriceList.vue"),
                  meta: {
                      permissions: ['price-lists-create']
                  }
                },
                {
                  path: "/price-lists/:id",
                  name: "price-lists-edit",
                  beforeEnter: AuthGuard,
                  component: () => import("@/views/pages/priceLists/EditPriceList.vue"),
                  meta: {
                      permissions: ['price-lists-view-self', 'price-lists-view-team', 'price-lists-view-all']
                  }
                },
                {
                    path: "/users",
                    name: "users",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/users/Users.vue"),
                    meta: {
                        permissions: ['users-view-self', 'users-view-team', 'users-view-all']
                    }
                },
                {
                    path: "users/new-user",
                    name: "new-user",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/users/StoreUser.vue"),
                    meta: {
                        permissions: ['users-create']
                    }
                },
                {
                    path: "users/:id",
                    name: "edit-user",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/users/StoreUser.vue"),
                    meta: {
                        permissions: ['users-edit']
                    }
                },
                {
                    path: "/teams",
                    name: "teams",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/teams/Teams.vue"),
                    meta: {
                        permissions: ['teams-view-self', 'teams-view-team', 'teams-view-all']
                    }
                },
                {
                    path: "teams/new-team",
                    name: "new-team",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/teams/StoreTeam.vue"),
                    meta: {
                        permissions: ['teams-create']
                    }
                },
                {
                    path: "teams/:id",
                    name: "edit-team",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/teams/StoreTeam.vue"),
                    meta: {
                        permissions: ['teams-edit']
                    }
                },
                {
                    path: "/companies",
                    name: "companies",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/companies/ListCompanies.vue"),
                    meta: {
                        permissions: ['companies-view-all']
                    }
                },
                {
                    path: "companies/create",
                    name: "companies-create",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/companies/EditCompany.vue"),
                    meta: {
                        permissions: ['companies-create']
                    }
                },
                {
                    path: "companies/:id/edit",
                    name: "companies-edit",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/companies/EditCompany.vue"),
                    meta: {
                        permissions: ['companies-edit']
                    }
                },
                {
                    path: "companies/:id",
                    name: "companies-view",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/companies/ViewCompany.vue"),
                    meta: {
                        permissions: ['companies-view-all']
                    }
                },
                {
                    path: "/company-contacts",
                    name: "company-contacts",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/companyContacts/ListCompanyContacts.vue"),
                    meta: {
                        permissions: ['company-contacts-view-all']
                    }
                },
                {
                    path: "company-contacts/create",
                    name: "company-contacts-create",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/companyContacts/EditCompanyContact.vue"),
                    meta: {
                        permissions: ['company-contacts-create']
                    }
                },
                {
                    path: "company-contacts/:id/edit",
                    name: "company-contacts-edit",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/companyContacts/EditCompanyContact.vue"),
                    meta: {
                        permissions: ['company-contacts-edit']
                    }
                },
                {
                    path: "company-contacts/:id",
                    name: "company-contacts-view",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/companyContacts/ViewCompanyContact.vue"),
                    meta: {
                        permissions: ['company-contacts-view-all']
                    }
                },
                {
                    path: "/pipelines-list",
                    name: "pipelines",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/pipelines/ListPipelines.vue"),
                    meta: {
                        permissions: ['pipelines-view-all']
                    }
                },
                {
                    path: "pipelines/create",
                    name: "pipelines-create",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/pipelines/EditPipeline.vue"),
                    meta: {
                        permissions: ['pipelines-create']
                    }
                },
                {
                    path: "pipelines/:id/edit",
                    name: "pipelines-edit",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/pipelines/EditPipeline.vue"),
                    meta: {
                        permissions: ['pipelines-edit']
                    }
                },
                {
                    path: "pipelines/:id",
                    name: "pipelines-view",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/pipelines/ViewPipeline.vue"),
                    meta: {
                        permissions: ['pipelines-view-all'],
                        hideSubheader: true,
                        fluidContainer: true
                    }
                },
                {
                    path: "/deals-list",
                    name: "deals-list",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/deals/ListDeals.vue"),
                    meta: {
                        permissions: ['deals-view-all']
                    }
                },
                {
                    path: "/deals/:id",
                    name: "deals-view",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/deals/ViewDeal.vue"),
                    meta: {
                        permissions: ['deals-view-all']
                    }
                },
                {
                    path: "/deal-statuses",
                    name: "deal-statuses",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/dealStatuses/ListDealStatuses.vue"),
                    meta: {
                        permissions: ['deal-statuses-view-all']
                    }
                },
                {
                    path: "deal-statuses/create",
                    name: "deal-statuses-create",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/dealStatuses/EditDealStatus.vue"),
                    meta: {
                        permissions: ['deal-statuses-create']
                    }
                },
                {
                    path: "deal-statuses/:id/edit",
                    name: "deal-statuses-edit",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/dealStatuses/EditDealStatus.vue"),
                    meta: {
                        permissions: ['deal-statuses-edit']
                    }
                },
                {
                    path: "/deal-document-types",
                    name: "deal-document-types",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/dealDocumentTypes/ListDealDocumentTypes.vue"),
                    meta: {
                        permissions: ['deal-document-types-view-all']
                    }
                },
                {
                    path: "deal-document-types/create",
                    name: "deal-document-types-create",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/dealDocumentTypes/EditDealDocumentType.vue"),
                    meta: {
                        permissions: ['deal-document-types-create']
                    }
                },
                {
                    path: "deal-document-types/:id/edit",
                    name: "deal-document-types-edit",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/dealDocumentTypes/EditDealDocumentType.vue"),
                    meta: {
                        permissions: ['deal-document-types-edit']
                    }
                },
                {
                    path: "/deal-types",
                    name: "deal-types",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/dealTypes/ListDealTypes.vue"),
                    meta: {
                        permissions: ['deal-types-view-all']
                    }
                },
                {
                    path: "deal-types/create",
                    name: "deal-types-create",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/dealTypes/EditDealType.vue"),
                    meta: {
                        permissions: ['deal-types-create']
                    }
                },
                {
                    path: "deal-types/:id/edit",
                    name: "deal-types-edit",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/dealTypes/EditDealType.vue"),
                    meta: {
                        permissions: ['deal-types-edit']
                    }
                },
                {
                    path: "/stock/warehouses",
                    name: "stock-warehouses",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/stock/warehouses/StockListWarehouses.vue"),
                    meta: {
                        permissions: ['stock-warehouses-view-all']
                    }
                },
                {
                    path: "/stock/warehouses/create",
                    name: "stock-warehouses-create",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/stock/warehouses/StockEditWarehouse.vue"),
                    meta: {
                        permissions: ['stock-warehouses-create']
                    }
                },
                {
                    path: "/stock/warehouses/:id/edit",
                    name: "stock-warehouses-edit",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/stock/warehouses/StockEditWarehouse.vue"),
                    meta: {
                        permissions: ['stock-warehouses-edit']
                    }
                },
                {
                    path: "/stock/products",
                    name: "stock-products",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/stock/products/StockListProducts.vue"),
                    meta: {
                        permissions: ['stock-products-view-all']
                    }
                },
                {
                    path: "/stock/products/create",
                    name: "stock-products-create",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/stock/products/StockEditProduct.vue"),
                    meta: {
                        permissions: ['stock-products-create']
                    }
                },
                {
                    path: "/stock/products/:id/edit",
                    name: "stock-products-edit",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/stock/products/StockEditProduct.vue"),
                    meta: {
                        permissions: ['stock-products-edit']
                    }
                },
                {
                    path: "/stock/inventory",
                    name: "stock-inventory",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/stock/inventory/StockInventory.vue"),
                    meta: {
                        permissions: ['stock-inventory-view-all']
                    }
                },
                {
                    path: "/stock/average-costs",
                    name: "stock-average-costs",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/stock/averageCosts/StockAverageCosts.vue"),
                    meta: {
                        permissions: ['stock-inventory-view-all']
                    }
                },
                {
                    path: "/stock/purchase-orders",
                    name: "stock-purchase-orders",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/stock/purchaseOrders/StockListPurchaseOrders.vue"),
                    meta: {
                        permissions: ['stock-purchase-orders-view-all']
                    }
                },
                {
                    path: "/stock/purchase-orders/create",
                    name: "stock-purchase-orders-create",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/stock/purchaseOrders/StockViewPurchaseOrder.vue"),
                    meta: {
                        permissions: ['stock-purchase-orders-create']
                    }
                },
                {
                    path: "/stock/purchase-orders/:id",
                    name: "stock-purchase-orders-view",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/stock/purchaseOrders/StockViewPurchaseOrder.vue"),
                    meta: {
                        permissions: ['stock-purchase-orders-view-all', 'stock-purchase-orders-edit']
                    }
                },
                {
                    path: "/stock/sales-orders",
                    name: "stock-sales-orders",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/stock/salesOrders/StockListSalesOrders.vue"),
                    meta: {
                        permissions: ['stock-sales-orders-view-all']
                    }
                },
                {
                    path: "/stock/sales-orders/create",
                    name: "stock-sales-orders-create",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/stock/salesOrders/StockViewSalesOrder.vue"),
                    meta: {
                        permissions: ['stock-sales-orders-create']
                    }
                },
                {
                    path: "/stock/sales-orders/:id",
                    name: "stock-sales-orders-view",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/stock/salesOrders/StockViewSalesOrder.vue"),
                    meta: {
                        permissions: ['stock-sales-orders-view-all', 'stock-sales-orders-edit']
                    }
                },
                {
                    path: "/stock/transport-orders",
                    name: "stock-transport-orders",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/stock/transportOrders/StockListTransportOrders.vue"),
                    meta: {
                        permissions: ['stock-transport-orders-view-all']
                    }
                },
                {
                    path: "/stock/transport-orders/create",
                    name: "stock-transport-orders-create",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/stock/transportOrders/StockViewTransportOrder.vue"),
                    meta: {
                        permissions: ['stock-transport-orders-create']
                    }
                },
                {
                    path: "/stock/transport-orders/:id/edit",
                    name: "stock-transport-orders-edit",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/stock/transportOrders/StockViewTransportOrder.vue"),
                    meta: {
                        permissions: ['stock-transport-orders-edit']
                    }
                },
                {
                    path: "/stock/transport-orders/:id",
                    name: "stock-transport-orders-view",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/stock/transportOrders/StockViewTransportOrder.vue"),
                    meta: {
                        permissions: ['stock-transport-orders-view-all', 'stock-transport-orders-edit']
                    }
                },
                {
                    path: "/stock/invoices",
                    name: "stock-invoices",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/stock/invoices/StockListInvoices.vue"),
                    meta: {
                        permissions: ['stock-invoices-view-all']
                    }
                },
                {
                    path: "/stock/invoices/create",
                    name: "stock-invoices-create",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/stock/invoices/StockViewInvoice.vue"),
                    meta: {
                        permissions: ['stock-invoices-create']
                    }
                },
                {
                    path: "/stock/invoices/:id",
                    name: "stock-invoices-view",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/stock/invoices/StockViewInvoice.vue"),
                    meta: {
                        permissions: ['stock-invoices-view-all', 'stock-invoices-edit']
                    }
                },
                {
                    path: "/stock/sales/create",
                    name: "stock-sales-create",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/stock/sales/StockViewSale.vue"),
                    meta: {
                        permissions: ['stock-sales-create']
                    }
                },
                {
                    path: "/stock/sales/:id",
                    name: "stock-sales-view",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/stock/sales/StockViewSale.vue"),
                    meta: {
                        permissions: ['stock-sales-view-all', 'stock-sales-edit']
                    }
                },
                {
                    path: "/stock/write-offs/create",
                    name: "stock-write-offs-create",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/stock/writeOffs/StockViewWriteOff.vue"),
                    meta: {
                        permissions: ['stock-write-offs-create']
                    }
                },
                {
                    path: "/stock/write-offs/:id",
                    name: "stock-write-offs-view",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/stock/writeOffs/StockViewWriteOff.vue"),
                    meta: {
                        permissions: ['stock-write-offs-view-all', 'stock-write-offs-edit']
                    }
                },
                {
                    path: "/stock/transfers/create",
                    name: "stock-transfers-create",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/stock/transfers/StockViewTransfer.vue"),
                    meta: {
                        permissions: ['stock-transfers-create']
                    }
                },
                {
                    path: "/stock/transfers/:id",
                    name: "stock-transfers-view",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/stock/transfers/StockViewTransfer.vue"),
                    meta: {
                        permissions: ['stock-transfers-view-all', 'stock-transfers-edit']
                    }
                },
                {
                    path: "/stock/transfer-orders",
                    name: "stock-transfer-orders",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/stock/transferOrders/StockListTransferOrders.vue"),
                    meta: {
                        permissions: ['stock-transfer-orders-view-all']
                    }
                },
                {
                    path: "/stock/transfer-orders/create",
                    name: "stock-transfer-orders-create",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/stock/transferOrders/StockViewTransferOrder.vue"),
                    meta: {
                        permissions: ['stock-transfer-orders-create']
                    }
                },
                {
                    path: "/stock/transfer-orders/:id",
                    name: "stock-transfer-orders-view",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/stock/transferOrders/StockViewTransferOrder.vue"),
                    meta: {
                        permissions: ['stock-transfer-orders-view-all', 'stock-transfer-orders-edit']
                    }
                },
                {
                    path: "/stock/revisions",
                    name: "stock-revisions",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/stock/revisions/StockListRevisions.vue"),
                    meta: {
                        permissions: ['stock-revisions-view-all']
                    }
                },
                {
                    path: "/stock/revisions/create",
                    name: "stock-revisions-create",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/stock/revisions/StockRevisionWizard.vue"),
                    meta: {
                        permissions: ['stock-revisions-create']
                    }
                },
                {
                    path: "/stock/revisions/edit-last",
                    name: "stock-revisions-edit-last",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/stock/revisions/StockRevisionWizard.vue"),
                    meta: {
                        permissions: ['stock-revisions-edit']
                    }
                },
                {
                    path: "/stock/revisions/:id/edit",
                    name: "stock-revisions-edit",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/stock/revisions/StockRevisionWizard.vue"),
                    meta: {
                        permissions: ['stock-revisions-create', 'stock-revisions-edit']
                    }
                },
                {
                    path: "/stock/revisions/:id",
                    name: "stock-revisions-view",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/stock/revisions/StockViewRevision.vue"),
                    meta: {
                        permissions: ['stock-revisions-view-all', 'stock-revisions-edit']
                    }
                },
                {
                    path: "/stock/movements",
                    name: "stock-movements",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/stock/movements/StockListMovements.vue"),
                    meta: {
                        permissions: ['stock-receipts-view-all']
                    }
                },
                {
                    path: "/stock/product-movements",
                    name: "stock-product-movements",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/stock/productMovements/StockProductMovements.vue"),
                    meta: {
                        permissions: ['stock-receipts-view-all']
                    }
                },
                {
                    path: "/stock/receipts",
                    redirect: "/stock/movements",
                },
                {
                    path: "/stock/receipts/create",
                    name: "stock-receipts-create",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/stock/receipts/StockViewReceipt.vue"),
                    meta: {
                        permissions: ['stock-receipts-create']
                    }
                },
                {
                    path: "/stock/receipts/multi-po/create",
                    name: "stock-receipts-multi-po-create",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/stock/receipts/StockMultiPoReceiptSession.vue"),
                    meta: {
                        permissions: ['stock-receipts-create']
                    }
                },
                {
                    path: "/stock/receipts/multi-po/:id",
                    name: "stock-receipts-multi-po-view",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/stock/receipts/StockMultiPoReceiptSession.vue"),
                    meta: {
                        permissions: ['stock-receipts-view-all', 'stock-receipts-edit']
                    }
                },
                {
                    path: "/stock/receipts/:id",
                    name: "stock-receipts-view",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/stock/receipts/StockViewReceipt.vue"),
                    meta: {
                        permissions: ['stock-receipts-view-all', 'stock-receipts-edit']
                    }
                },
                {
                    path: "/stock/product-departments",
                    name: "stock-product-departments",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/stock/productDepartments/StockListProductDepartments.vue"),
                    meta: {
                        permissions: ['stock-product-departments-view-all']
                    }
                },
                {
                    path: "/stock/product-departments/create",
                    name: "stock-product-departments-create",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/stock/productDepartments/StockEditProductDepartment.vue"),
                    meta: {
                        permissions: ['stock-product-departments-create']
                    }
                },
                {
                    path: "/stock/product-departments/:id/edit",
                    name: "stock-product-departments-edit",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/stock/productDepartments/StockEditProductDepartment.vue"),
                    meta: {
                        permissions: ['stock-product-departments-edit']
                    }
                },
                {
                    path: "/stock/product-categories",
                    name: "stock-product-categories",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/stock/productCategories/StockListProductCategories.vue"),
                    meta: {
                        permissions: ['stock-product-categories-view-all']
                    }
                },
                {
                    path: "/stock/product-categories/create",
                    name: "stock-product-categories-create",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/stock/productCategories/StockEditProductCategory.vue"),
                    meta: {
                        permissions: ['stock-product-categories-create']
                    }
                },
                {
                    path: "/stock/product-categories/:id/edit",
                    name: "stock-product-categories-edit",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/stock/productCategories/StockEditProductCategory.vue"),
                    meta: {
                        permissions: ['stock-product-categories-edit']
                    }
                },
                {
                    path: "/stock/packagings",
                    name: "stock-packagings",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/stock/packagings/StockListPackagings.vue"),
                    meta: {
                        permissions: ['stock-packagings-view-all']
                    }
                },
                {
                    path: "/stock/packagings/create",
                    name: "stock-packagings-create",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/stock/packagings/StockEditPackaging.vue"),
                    meta: {
                        permissions: ['stock-packagings-create']
                    }
                },
                {
                    path: "/stock/packagings/:id/edit",
                    name: "stock-packagings-edit",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/stock/packagings/StockEditPackaging.vue"),
                    meta: {
                        permissions: ['stock-packagings-edit']
                    }
                },
                {
                    path: "/stock/units",
                    name: "stock-units",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/stock/units/StockListUnits.vue"),
                    meta: {
                        permissions: ['stock-units-view-all']
                    }
                },
                {
                    path: "/stock/units/create",
                    name: "stock-units-create",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/stock/units/StockEditUnit.vue"),
                    meta: {
                        permissions: ['stock-units-create']
                    }
                },
                {
                    path: "/stock/units/:id/edit",
                    name: "stock-units-edit",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/stock/units/StockEditUnit.vue"),
                    meta: {
                        permissions: ['stock-units-edit']
                    }
                },
                {
                    path: "/list-offers",
                    name: "list-offers",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/listOffers/ListOffers.vue"),
                    meta: {
                        permissions: ['offers-view-self', 'offers-view-team', 'offers-view-all'],
                        hideSubheader: true,
                        fluidContainer: true
                    }
                },
                {
                    path: "aliases",
                    name: "aliases",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/aliases/ShowAliases.vue"),
                    meta: {
                        permissions: []
                    }
                },
                {
                    path: "aliases/:id",
                    name: "edit-alias",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/aliases/EditAlias.vue"),
                    meta: {
                        permissions: ['aliases-edit']
                    }
                },
                {
                    path: "mappings",
                    name: "mappings",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/mappings/ShowMappings.vue"),
                    meta: {
                        permissions: ['mappings-view-self', 'mappings-view-team', 'mappings-view-all']
                    }
                },
                {
                    path: "mapping/:id",
                    name: "edit-mappings",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/mappings/EditMapping.vue"),
                    meta: {
                        permissions: ['mappings-edit']
                    }
                },
                {
                    path: "mapping",
                    name: "create-mappings",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/mappings/EditMapping.vue"),
                    meta: {
                        permissions: ['mappings-create']
                    }
                },
                {
                  path: "mapping-values/:mappingId",
                  name: "edit-mapping-values",
                  beforeEnter: AuthGuard,
                  component: () => import("@/views/pages/mappings/EditMappingValues.vue"),
                  meta: {
                      permissions: ['mapping-values-view-self', 'mapping-values-view-team', 'mapping-values-view-all']
                  }
              },
                {
                    path: "/unit-conversions",
                    name: "unit-conversions",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/unitConversions/ListUnitConversions.vue"),
                    meta: {
                        permissions: ['unit-conversions-view-all']
                    }
                },
                {
                    path: "unit-conversions/create",
                    name: "unit-conversions-create",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/unitConversions/EditUnitConversion.vue"),
                    meta: {
                        permissions: ['unit-conversions-create']
                    }
                },
                {
                    path: "unit-conversions/:id/edit",
                    name: "unit-conversions-edit",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/unitConversions/EditUnitConversion.vue"),
                    meta: {
                        permissions: ['unit-conversions-edit']
                    }
                },
                {
                  path: "transport-data",
                  name: "transport-data",
                  beforeEnter: AuthGuard,
                  component: () => import("@/views/pages/transportData/ShowTransportData.vue"),
                  meta: {
                      permissions: ['transport-data-view-self', 'transport-data-view-team', 'transport-data-view-all']
                  }
                },
                {
                    path: "price-config",
                    name: "price-config",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/config/Config.vue"),
                    meta: {
                        permissions: ['price-config-self', 'price-config-team', 'price-config-all']
                    }
                },
                {
                    path: "/field-tag-types",
                    name: "field-tag-types",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/fieldTags/ListFieldTagTypes.vue"),
                    meta: {
                        permissions: ['field-tags-view-all']
                    }
                },
                {
                    path: "/field-tag-types/:fieldTagTypeId/tags",
                    name: "field-tags",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/fieldTags/ListFieldTags.vue"),
                    meta: {
                        permissions: ['field-tags-view-all']
                    }
                },
                {
                    path: "field-tag-types/:fieldTagTypeId/tags/create",
                    name: "field-tags-create",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/fieldTags/EditFieldTag.vue"),
                    meta: {
                        permissions: ['field-tags-create']
                    }
                },
                {
                    path: "field-tag-types/:fieldTagTypeId/tags/:tagId/edit",
                    name: "field-tags-edit",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/fieldTags/EditFieldTag.vue"),
                    meta: {
                        permissions: ['field-tags-edit']
                    }
                },
                {
                    path: "/incoterms",
                    name: "incoterms",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/incoterms/ListIncoterms.vue"),
                    meta: {
                        permissions: ['incoterms-view-all']
                    }
                },
                {
                    path: "incoterms/create",
                    name: "incoterms-create",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/incoterms/EditIncoterm.vue"),
                    meta: {
                        permissions: ['incoterms-create']
                    }
                },
                {
                    path: "incoterms/:id/edit",
                    name: "incoterms-edit",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/incoterms/EditIncoterm.vue"),
                    meta: {
                        permissions: ['incoterms-edit']
                    }
                },
                {
                    path: "list-price",
                    name: "pricing",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/pricing/ShowPricing.vue"),
                    meta: {
                        permissions: ['pricing-view-self', 'pricing-view-team', 'pricing-view-all']
                    }
                },
                {
                    path: "pricing/:id",
                    name: "edit-pricing",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/pricing/EditPricing.vue"),
                    meta: {
                        permissions: ['pricing-edit']
                    }
                },
                {
                    path: "pricing",
                    name: "create-pricing",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/pricing/EditPricing.vue"),
                    meta: {
                        permissions: ['pricing-create']
                    }
                }
            ]
        },
        {
            path: "/",
            component: () => import("@/views/pages/auth/Auth"),
            children: [
                {
                    name: "login",
                    path: "/login",
                    component: () => import("@/views/pages/auth/Login")
                },
                {
                    name: "register",
                    path: "/register",
                    component: () => import("@/views/pages/auth/Register")
                },
                {
                    name: "forgot",
                    path: "/forgot",
                    component: () => import("@/views/pages/auth/Forgot")
                },
                {
                    name: "reset",
                    path: "/reset/:token/:email",
                    component: () => import("@/views/pages/auth/Reset")
                }
            ]
        },
        {
          path: "/google-redirect",
          name: "google-redirect",
          component: () => import("@/views/pages/auth/GoogleRedirect")
        },
        {
            path: "*",
            redirect: "/404",
        },
        {
            // the 404 route, when none of the above matches
            path: "/404",
            name: "404",
            component: () => import("@/views/pages/error/Error-1.vue")
        }
    ]
});
